const resource = 'article_types'

export default $axios => ({
  fetch(params) {
    return $axios.$get(`/${resource}`, { params })
  },

  getServiceName: name => 'articleTypeService',
})
